import api from '../api';
import { ContractDocument } from '../../types/compliance';
import { saveAs } from '../../utils/saveFile';

// NOTE: axios baseURL already ends in `/api/v1`; paths here are relative.
const base = (contractId: string) => `/compliance/contracts/${contractId}/documents`;

export const contractDocumentsService = {
  async list(contractId: string): Promise<ContractDocument[]> {
    const { data } = await api.get<ContractDocument[]>(base(contractId));
    return data;
  },

  async upload(
    contractId: string,
    file: File,
    description: string,
  ): Promise<ContractDocument> {
    const form = new FormData();
    form.append('file', file);
    form.append('description', description || '');
    const { data } = await api.post<ContractDocument>(base(contractId), form, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return data;
  },

  async download(contractId: string, docId: string, filename: string): Promise<void> {
    await saveAs(filename, async () => {
      const response = await api.get(`${base(contractId)}/${docId}/download`, {
        responseType: 'blob',
      });
      const contentType =
        (response.headers && (response.headers as any)['content-type']) ||
        'application/octet-stream';
      return new Blob([response.data], { type: contentType });
    });
  },

  async update(
    contractId: string,
    docId: string,
    description: string,
  ): Promise<ContractDocument> {
    const { data } = await api.patch<ContractDocument>(
      `${base(contractId)}/${docId}`,
      { description },
    );
    return data;
  },

  async remove(contractId: string, docId: string): Promise<void> {
    await api.delete(`${base(contractId)}/${docId}`);
  },
};

export default contractDocumentsService;
